export default Object.freeze({
  'CHECK': 'check',
  'CLOSE': 'close',
  'CUP': 'cup',
  'PAPERS': 'papers',
  'TAG': 'tag'
});
